import React from 'react';

export const AuthContext = React.createContext<{ auth: boolean; user: any }>({
  auth: false,
  user: null,
});
